<key-leaflet-map class="flex-1 position-relative" #map [loading]="!telemetry"></key-leaflet-map>
